var CompanySize = {
	"Company size": "公司规模",
	"1-19 employees": "1-19 名员工",
	"20-99 employees": "20-99 名员工",
	"100-499 employees": "100-499 名员工",
	"500-999 employees": "500-999 名员工",
	"1,000-9,999 employees": "1000-9999 名员工",
	"10,000 employees or more": "10000 名员工或以上"
};

export { CompanySize as default };
